import {
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  TextField
} from '@material-ui/core';
import { useState } from 'react';
import { validateTagInput } from '../../utils/tagValidatorUtils';

const CaptureWithTag = ({
  edit,
  tags,
  inputTagName,
  inputCommentName,
  radioButtonValue,
  handleTagInputChange,
  handleCommentInputChange,
  handleRadioChange,
  tagError,
  setTagError,
  saveFlagWithTag,
  onClose
}) => {
  const [selectedValue, setSelectedValue] = useState('');

  const onHandleChange = (event) => {
    setSelectedValue(event.target.value);
    handleRadioChange(event.target.value);
  };

  const onHandleChangeInputTag = (event) => {
    setSelectedValue('');
    handleTagInputChange(event);
  };

  const handleButtonSave = () => {
    if (!edit) {
      const [isValid, errorMessage] = validateTagInput(inputTagName);

      if (!isValid && errorMessage) {
        setTagError({
          hasError: true,
          errorMessage
        });
        return;
      }
    }
    saveFlagWithTag(inputTagName, inputCommentName);
    onClose();
  };

  //if there are more tags with same name, get only one of this tag
  const listOfTags = () => {
    const list = new Map();
    tags?.forEach((item) => {
      if (item.tag !== 'DOWNTAG' && item.tag !== 'UPTAG') {
        list.set(item.tag, item);
      }
    });

    return Array.from(list.values());
  };

  const listLength = listOfTags()?.length;

  return (
    <div>
      {!edit ? (
        <>
          <Grid
            item
            className="capture-flags-modal__create-textfield-container"
          >
            <TextField
              className="capture-flags-modal__create-input-textfield"
              placeholder="Add a tag"
              inputProps={{ 'aria-label': 'create tag input' }}
              value={inputTagName}
              onChange={onHandleChangeInputTag}
            />
          </Grid>
          {tagError.hasError ? (
            <Grid className="capture-flags-modal__create-input-error" container>
              <Grid item>
                <span className="create-tag-error">
                  {tagError.errorMessage}
                </span>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
          <FormGroup className="capture-flags-modal__form-group">
            <div>
              {listOfTags().map((tag, index) => (
                <div key={tag.tag}>
                  <div className="capture-flags-modal__tag-list-item">
                    <Grid className="list-item-container" container>
                      <Grid item xs={10} className="list-item-tag-info">
                        <span className="list-title">{tag.tag}</span>
                      </Grid>
                      <Grid item xs={2}>
                        <RadioGroup
                          className="capture-flags-modal__checkbox"
                          onChange={onHandleChange}
                          value={selectedValue}
                        >
                          <FormControlLabel
                            value={tag.tag}
                            control={<Radio />}
                          />
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </div>
                  {index !== listLength - 1 && (
                    <Divider
                      className="capture-flags-modal__divider"
                      variant="middle"
                      style={{ marginBottom: '6px' }}
                    />
                  )}
                </div>
              ))}
            </div>
          </FormGroup>
        </>
      ) : (
        <></>
      )}
      <Grid item className="capture-flags-modal__create-textfield-container">
        <TextField
          className="capture-flags-modal__create-input-textfield"
          placeholder="Add a comment"
          inputProps={{ 'aria-label': 'create comment input' }}
          value={inputCommentName}
          onChange={handleCommentInputChange}
          multiline
          minRows={1}
          maxRows={3}
        />
      </Grid>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: '20px' }}
      >
        <Grid item xs={12}>
          <Button
            className="capture-flags-modal-save-btn"
            style={{ justifyContent: 'center' }}
            onClick={handleButtonSave}
          >
            <span className="btn__title">Save</span>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default CaptureWithTag;
